import { MenuScreenRepository } from '../../domain/repositories/MenuScreenRepository'
import { MenuScreenModel } from '../models/MenuScreenModel'
import { CreateUpdateMenuScreenModel } from '../models/CreateUpdateMenuScreenModel'
import type { CreateUpdateMenuScreenEntity } from '../../domain/entities/CreateUpdateMenuScreenEntity'
import type { MenuScreenEntity } from '../../domain/entities/MenuScreenEntity'
import {
  MenuScreensService,
  type PostMenuScreenRequestAdmin,
  type PutMenuScreenRequestAdmin
} from '@/backend/market'

export class MenuScreenRepositoryImpl implements MenuScreenRepository {
  async getMenuScreens(isActive?: boolean): Promise<MenuScreenEntity[] | { error: true }> {
    try {
      const response = await MenuScreensService.getMenuScreensAdmin({ isActive })
      return (response ?? []).map((item) => new MenuScreenModel(item))
    } catch {
      return { error: true }
    }
  }
  async createMenuScreen(
    menuScreen: CreateUpdateMenuScreenEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateMenuScreenModel = new CreateUpdateMenuScreenModel(menuScreen)
    try {
      await MenuScreensService.createMenuScreenAdmin({
        requestBody: createUpdateMenuScreenModel as PostMenuScreenRequestAdmin
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateMenuScreen(
    id: string,
    menuScreen: CreateUpdateMenuScreenEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateMenuScreenModel = new CreateUpdateMenuScreenModel(menuScreen)
    try {
      await MenuScreensService.updateMenuScreenAdmin({
        id,
        requestBody: createUpdateMenuScreenModel as PutMenuScreenRequestAdmin
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deleteMenuScreen(id: string): Promise<{ success: true } | { error: true }> {
    try {
      await MenuScreensService.deleteMenuScreenAdmin({ id })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
